/*
CACHES A FUNCTION RESULT
Useful if an long function always returns the same result and can be called accross the code

Example:
const myAPICall = cached(() => fetch('/endpoint').then(r => r.json()));
const res1 = await myAPICall(); // actually calls the api
const res2 = await myAPICall(); // returns a resolved promise, so instantly goes through
// res1 === res2

Important note:
While it passes the arguments down to the function, it does not cache based on them
This can lead to unexpected results if the function expects any non-constant argument, example:

let getColorValue = cached(color => color);
let blue = getColorValue('blue');
let red = getColorValue('red'); // THIS WILL RETURN BLUE
*/

export default function cached(fn) {
	let ran = false;
	let cache;
	let clearTimer;
	let cachedFunc = function() {
		if (!ran) {
			ran = true;
			cache = fn.apply(this, arguments);
		}
		return cache;
	};
	cachedFunc.expireIn = (ms) => {
		clearTimer = setTimeout(() => this.reset(), ms);
	};
	cachedFunc.reset = () => {
		clearTimeout(clearTimer);
		ran = false;
	};
	cachedFunc.force = function() {
		cachedFunc.reset();
		cachedFunc.apply(this, arguments);
	};
	return cachedFunc;
}
